
import { Component, Vue } from 'vue-property-decorator';
import { Heading } from '@warrenbrasil/nebraska-web';
import {
  GlobalSummaryInbox,
  HomeInboxDocument,
  HomeInboxQuery
} from '@/modules/common/services/graphql/server/server.sdk';
import { IFeedItem } from '@/modules/home/services/news';
import { trackNewsClick, trackNewsRemoveClick } from './track-events';
import { DocumentModule } from '@/modules/pension/store/document';
import OverviewInbox from '../OverviewInbox/OverviewInbox.vue';

@Component({
  components: {
    Heading,
    OverviewInbox
  }
})
export default class HomeNews extends Vue {
  hasError = false;
  inbox: Reactive<GlobalSummaryInbox> = null;

  created() {
    this.loadInbox();
    this.loadPensionSuggestions();
  }

  trackView(news: IFeedItem) {
    trackNewsClick(news.dashboardTitle, news.id);
  }

  trackRemove(news: IFeedItem) {
    trackNewsRemoveClick(news.dashboardTitle, news.id);
  }

  private async loadInbox() {
    try {
      const { data } = await this.$apollo.query<HomeInboxQuery>({
        query: HomeInboxDocument
      });
      this.inbox = data.globalSummary?.inbox!;
    } catch {
      // Ignore error
    }
  }

  private loadPensionSuggestions() {
    DocumentModule.fetchDocuments();
  }
}
